$(document).ready(function () {

    if (window.location.href.indexOf('installation_idel') > 0) {
        $('.label-adeli').on('click', function() { resetButtons($('.label-rpps')); });
        $('.label-rpps').on('click', function() { resetButtons($('.label-adeli')); });
    }

    /*
     API dataNovaPoste: https://datanova.laposte.fr/api/v1/console/datasets/1.0/search/
     Utiliser pour l'autocomplétion du champs code postal
     */


    /* Pour la partie information démographique*/
    var options = {
        minCharNumber: 2,
        url: function (phrase) {
            //return "https://datanova.laposte.fr/api/records/1.0/search/?dataset=laposte_hexasmal&q=" + phrase + "&facet=code_commune_insee&facet=nom_de_la_commune&facet=code_postal";
            return "https://datanova.laposte.fr/data-fair/api/v1/datasets/laposte-hexasmal/lines?q=" + phrase + "&q_mode=complete";
        },

        listLocation: function (data) {
            var new_data = (data.results).map(function (item) {
                return {
                    label: item.code_postal + " - " + item.nom_de_la_commune,
                    cp: item.code_postal,
                    commune: item.nom_de_la_commune,
                    insee: item.code_commune_insee
                };
            });
            return new_data;
        },

        getValue: function (element) {
            return element.label;
        },

        list: {
            maxNumberOfElements: 10,
            match: {
                enabled: true
            },
            onChooseEvent: function () {
                var index = $("#cp_installaion_idel_codePostal, #cp_installaion_demographique_commune_codePostal").getSelectedItemData();
                $('#cp_installaion_idel_commune, #cp_installaion_demographique_commune_commune').val(index.commune);
                $('#cp_installaion_idel_insee, #cp_installaion_demographique_commune_insee').val(index.insee);
            },
            onKeyEnterEvent: function () {
                var index = $("#cp_installaion_idel_codePostal, #cp_installaion_demographique_commune_codePostal").getSelectedItemData();
                $('#cp_installaion_idel_commune, #cp_installaion_demographique_commune_commune').val(index.commune);
                $('#cp_installaion_idel_insee, #cp_installaion_demographique_commune_insee').val(index.insee);
            }
        }
    };
    $("#cp_installaion_idel_codePostal, #cp_installaion_demographique_commune_codePostal").easyAutocomplete(options);


    /* Pour la partie identification*/
    var options2 = {
        minCharNumber: 2,
        url: function (phrase) {
            //return "https://datanova.laposte.fr/api/records/1.0/search/?dataset=laposte_hexasmal&q=" + phrase + "&facet=code_commune_insee&facet=nom_de_la_commune&facet=code_postal";
            return "https://datanova.laposte.fr/data-fair/api/v1/datasets/laposte-hexasmal/lines?q=" + phrase + "&q_mode=complete";
        },

        listLocation: function (data) {
            var new_data = (data.results).map(function (item) {
                return {
                    label: item.code_postal + " - " + item.nom_de_la_commune,
                    cp: item.code_postal,
                    commune: item.nom_de_la_commune,
                    insee: item.code_commune_insee
                };
            });
            return new_data;
        },

        getValue: function (element) {
            return element.label;
        },

        list: {
            maxNumberOfElements: 10,
            match: {
                enabled: true
            },
            onChooseEvent: function () {
                var index = $("#init_dossier_idel_codePostal").getSelectedItemData();
                $('#init_dossier_idel_insee').val(index.insee);
            }
        }
    };
    $("#init_dossier_idel_codePostal").easyAutocomplete(options2);

    //$("#cp_installaion_demographique_commune_codePostal,#init_dossier_idel_insee").keypress(function() {
    //    $('#cp_installaion_demographique_commune_insee,#init_dossier_idel_insee').val('000');
    //});


    //BO: Slider pour le bloc des pj de l'expérience professionnelle
    $('.liste-exp-professionnelle').slick({
        "vertical": true,
        verticalSwiping: true,
        "slidesToShow": 5,
        "slidesToScroll": 4,
        "prevArrow": '<button type="button" class="slick-prev"></button>',
        "nextArrow": '<button type="button" class="slick-next"></button>'
    });


    //BO: pour savoir si les fichiers de l'expérience professionnelle ont été consultés
    $('.checkbox [data-fichier]').on('click', function () {
        var id_file = $(this).data('fichier');
        var selected = $(this).is(':checked');

        $.ajax({
            url: $('#route_fichier_consulte').data('route'),
            data: {
                fichier_id: id_file,
                statut: selected
            },
            type: "POST",
            success: function (response) {
            },
            error: function (error) {
            }
        });
    });


    var nb_pj_justificatif = $('section').find('.fichier-transmis').length;
    if (nb_pj_justificatif > 0) {
        $('#transmettre_cnam').removeClass('disabled');
    } else {
        if (!$('#transmettre_cnam').hasClass('disabled')) {
            $('#transmettre_cnam').addClass('disabled');
        }
    }

    $("#transmettre_cnam").click(function (e) {
        $('#form-transmission').submit();
    });


    // Listen for clicks on the cancel icon
    $('#files').on('click', '.remove', function () {
        $(this).parent().fadeOut(300, function () {
            $(this).remove();
        });
    });

    //BO Caisse
    $(".file-uploader.bo-caisse input[type='file']").change(function (e) {
        console.log('dps:uploader');

        var id = $(this).closest('.file-uploader').data('id');

        $('#upload-file-' + id).addClass("active");
        $('#form-' + id).submit();
    });

    $('.confirme-suppresion-fichier-upload.bo-caisse').click(function () {
        var idDocumentDemarche = $(this).attr('data-id-document-demarche');
        var formAction = $(this).attr('data-form-action');

        $('#upload-file-' + idDocumentDemarche).addClass("active");
        $('#delete-document-form').attr('action', formAction);
        $('#delete-document-form').submit();
    });

    $('.confirme-suppresion-fichier-exp').click(function () {
        var formAction = $(this).attr('data-form-action');
        $('#delete-document-form-exp').attr('action', formAction);

        var fichier_id = $("<input>")
            .attr("type", "hidden")
            .attr("name", "fichier_id")
            .val( $(this).attr('data-fichier-id') );

        var dossier_id = $("<input>")
            .attr("type", "hidden")
            .attr("name", "dossier_id")
            .val( $(this).attr('data-dossier-id') );

        $('#delete-document-form-exp').append($(fichier_id));
        $('#delete-document-form-exp').append($(dossier_id));
        
        $('#delete-document-form-exp').submit();
    });

    rating('#rating-confirmation');

    /** Redirection vers rezone pour IM **/
    testRedirectRezone();

    function testRedirectRezone() {
        var url_rezone = $('#route_url_rezone').data('route');

        if (url_rezone !== "" && url_rezone !== undefined) {
            window.open(url_rezone);
        }
    }

});

function resetButtons(btn)
{
    $(btn).removeClass('active');
}
